export default __webpack_public_path__ + "static/media/star.6f09a733.png";